<template>
  <div>
    <div id="md-lg-screen-menu">
      <p
        v-for="item in items"
        :key="item.name + $store.state.selectedTeam.pendingPlan"
        class="hoverable-blue"
        :class="{ active: item.component === currentTab.component }"
        @click="selected(item)"
      >
        {{ item.name }}
        <img
          v-if="item.name === 'Billing' && (team.pendingPlan || team.status === 'incomplete')"
          class="payment_failed"
          :src="require('@/assets/_desktop/_settings/_icons/alert_icon.svg')"
        >
      </p>
    </div>
    <div id="sm-screen-menu">
      <p
        class="current-tab-name"
        @click="un_fold"
      >
        <span>
          {{ activeItem }}
          <img
            v-if="activeItem === 'Billing' && (team.pendingPlan || team.status === 'incomplete')"
            class="payment_failed"
            :src="require('@/assets/_desktop/_settings/_icons/alert_icon.svg')"
          >
        </span>
        <img
          v-if="folded"
          class="switch-arrow"
          src="~@/assets/ico/arrow-down-blue.svg"
          alt="arrow down"
        >
        <img
          v-else
          class="switch-arrow"
          src="~@/assets/ico/arrow-up-blue.svg"
          alt="arrow up"
        >
      </p>
      <transition name="slide">
        <div
          v-if="!folded"
          class="foldable-menu-wrapper"
        >
          <p
            v-for="item in items"
            :key="item.name"
            class="foldable-menu-element"
            :class="{ active: item.component === currentTab.component }"
            @click="
              un_fold()
              selected(item)
              
            "
          >
            {{ item.name }}
            <img
              v-if="item.name === 'Billing' && (team.pendingPlan || team.status === 'incomplete')"
              class="payment_failed"
              :src="require('@/assets/_desktop/_settings/_icons/alert_icon.svg')"
            >
          </p>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import Constants from '@/components/Constants'
import EventBus from '@/EventBus'

export default {
  mixins: [Constants],
  props: {
    items: Array,
    currentTab: Object,
    team: Object,
  },
  data() {
    return {
      active: '',
      folded: true,
    }
  },
  computed: {
    activeItem() {
      let arr = this.items.filter(it => it.component === this.currentTab.component)
      return arr[0].name
    },
  },
  created() {
    this.active = this.currentTab.component
    //this.$emit('input', this.currentTab)
  },
  methods: {
    selected(item) {
      this.active = item.component
      this.$emit('input', item)
      
      if (this.getUserSettingsTabs().map(el => el.component).includes(item.component)) {
        EventBus.$emit('component-selected', {
          componentName: 'UserSettings',
          tabName: item.component,
          type: 'item',
        })
      } else {
        EventBus.$emit('component-selected', {
          componentName: 'AdminSettings',
          tabName: item.component,
          teamId: this.team.teamId,
          type: 'teamSetting',
        })
      }
    },
    un_fold() {
      this.folded = !this.folded
    },
  },
}
</script>

<style lang="scss" scoped>
@include respond-above(sm) {
  #md-lg-screen-menu {
    display: flex;

    p {
      @include font-rule('averta-semibold');
      font-size: 16px;
      height: 20px;
      color: #161616;
      letter-spacing: 0.2px;
      line-height: 20px;
      cursor: pointer;
      padding: 28px 0 28px 0;
      margin: 0 18px 0 18px;
      box-sizing: content-box;
      @include animate-border-default(3px);
      .payment_failed {
        position: absolute;
      }
      &.active {
        color: $blue;
        @include animate-border-focused();
        &:hover {
          filter: none;
        }
      }
    }
  }
  #sm-screen-menu {
    display: none;
  }
}

@include respond-below(sm) {
  #sm-screen-menu {
    position: relative;
  }
  #md-lg-screen-menu {
    display: none;
  }
  /*img {
            position: relative;
            left: 179px;
        }*/
  p {
    padding: 18px 20px;
    margin: 0 0 0 0;
    display: inline-block;
    width: 100%;
    border-bottom: 1px solid $athens-gray;

    font-family: $semibold;
    font-size: 16px;
    line-height: 20px;
    color: $black;
    letter-spacing: 0.2px;
    cursor: pointer;

    // don't highlighting cursor blue on mobile browsers
    // #
    // TODO maybe everywhere?
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);

    &.current-tab-name {
      background-color: #ffffff; // to cover menu during unfolding
      z-index: 0;
      position: relative;

      border-top: 1px solid $athens-gray;
      display: flex;
      justify-content: space-between;

      span {
        @include font-rule('averta-semibold');
        color: $blue;
      }
      .switch-arrow {
      }
    }
  }
  // .foldable-menu-wrapper {
  //     //animation-duration: 1s;
  //     animation-duration: 0.2s;
  //     animation-name: slideDown;
  //     animation-timing-function: ease-in-out;
  // }

  // @keyframes slideDown {
  //     from {
  //         margin-top: -60px * 4;
  //         opacity: 0;
  //     }
  //     to {
  //         margin-top: 0;
  //         opacity: 1;
  //     }
  // }
}
</style>
